<template>
  <LotteryBasePage>
    <slot>
      <PickLotteryBasePlaySlip />
    </slot>
  </LotteryBasePage>
</template>
